import { isEmpty } from 'underscore';


export const useDataState = (allData, selectedData) => {
  let noDataMsgKey = null;
  const noData = isEmpty(allData);
  const noSelected = isEmpty(selectedData);

  if (noData && noSelected) {
    noDataMsgKey = _TL_('There are no Facebook posts to import from the last 90 days. To add posts to your website, post on your Facebook page first.');
  } else if (noSelected) {
    noDataMsgKey = _TL_('No posts selected to import from Facebook.');
  }

  return {
    noDataMsgKey,
    noData,
  };
};
